import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { extractErrorMessage } from "../../../../_config";
import { useAppLoader } from "./appLoaderHook";

export function useApiCall() {
  const dispatch = useDispatch();
  const { showLoader, hideLoader } = useAppLoader();

  const callApi = useCallback(
    (
      sagaAction: string,
      dataOrParams: any = {},
      callbackSuccess: (message: string, resp: any) => void,
      callbackError: (message: string, resp: any) => void,
      isLoader = true
    ) => {
      if (isLoader) showLoader();
      dispatch({
        type: sagaAction,
        payload: dataOrParams,
        callbackSuccess: (data: any) => {
          const message = data && data.message ? data.message : "Request processed successfully";
          const resp = data && data.data ? data.data : null;
          if (isLoader) hideLoader();
          callbackSuccess && callbackSuccess(message, resp);
        },
        callbackError: (error: any) => {
          const message = extractErrorMessage(
            error && error.data && error.data.errors ? error : error.message ? error.message : null,
            "Unable to process request, please try again"
          );
          const resp = error && error.data ? error.data : null;
          if (isLoader) hideLoader();
          callbackError && callbackError(message, resp);
        },
      });
    },
    [dispatch, showLoader, hideLoader]
  );

  return callApi;
}
